import { render } from "./IconInvested.vue?vue&type=template&id=d6e0ba38"
import script from "./IconInvested.vue?vue&type=script&lang=js"
export * from "./IconInvested.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__